import { render, staticRenderFns } from "./AdjustmentKerusakan.vue?vue&type=template&id=0572ed95&"
import script from "./AdjustmentKerusakan.vue?vue&type=script&lang=js&"
export * from "./AdjustmentKerusakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports